import React from "react";
import { group } from "radash";
import { ReportsTypes } from "@core";
import { Outlet } from "react-router";
import { useGlobalQuery } from "@hooks";
import { NavLink } from "@nubeteck/prime";
import { Divider } from "primereact/divider";

export interface IReportingLayoutProps {
  moduleId: number;
}

const ReportingLayout = ({ moduleId }: IReportingLayoutProps) => {
  const reports = useGlobalQuery("Reports", "getAllByModuleId", moduleId, {
    enabled: !!moduleId,
  });

  const renderIcon = React.useCallback((reportTypeId: number) => {
    if (!reportTypeId) return "ban";
    return reportTypeId === ReportsTypes.TICKET ? "receipt" : "report";
  }, []);

  const reportesGrouped = React.useMemo(() => {
    return group(reports.data ?? [], (item) => item.ReporteCategoriaNombre);
  }, [reports.data]);

  return (
    <div className="flex flex-column lg:flex-row gap-2 flex-1 h-full">
      <div className="flex w-full flex-column lg:w-16rem surface-card border-round shadow-2 select-none">
        <Divider className="mb-0 mt-1 z-0">
          <span className="text-sm font-semibold text-color">
            Menu de reportes
          </span>
        </Divider>
        <ul className="list-none w-full p-2 m-0 overflow-auto">
          {Object.entries(reportesGrouped).map(([categoryName, items]) => {
            return (
              <NavLink
                icon="category"
                key={categoryName}
                title={categoryName ?? ""}
                items={
                  items?.map((item) => {
                    return {
                      items: [],
                      to: `${item.ReporteId}`,
                      title: item.ReporteNombre,
                      icon: renderIcon(item.ReporteTipoId),
                    };
                  }) ?? []
                }
              />
            );
          })}
        </ul>
      </div>
      <div className="flex flex-1 h-full">
        <Outlet />
      </div>
    </div>
  );
};

export default ReportingLayout;
